<div class="search-filter">
  <div class="search-input-container">
    <form (ngSubmit)="onSubmit(form.value)" [formGroup]="form">
      <input
        [formControl]="form.controls['searchText']"
        autocomplete="off"
        class="search-input"
        i18n-placeholder="
          Placeholder for search for product field@@filter.search.placeholder"
        placeholder="Search for product"
        type="text"
      />

      <button type="submit">
        <svg class="icon-search" height="16" viewBox="0 0 16 16" width="16">
          <use xlink:href="/images/icons/svg-sprite.svg#search"></use>
        </svg>
      </button>
    </form>
  </div>
</div>
